import React from "react";
import "./MessageBar.scss";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import moment from "moment";

const MessageBar = () => {
	const { pathname } = useLocation();
	const stateKeys = useSelector(state => state?.websiteDetails?.data?.licenceKeys) ?? [];
	const testData = useSelector(state => state?.detectModes);
	const active = stateKeys.find((key) => key.status === "Active" && key.terminated === false);
	const trial = stateKeys.find((key) => key.status === "Trial" && key.terminated === false);
	const expired = stateKeys.find((key) => key.status === "Expired");
	const lastTraffic = useSelector((state) => state?.websiteDetails?.data?.websiteDetails?.last_traffic);

	switch (true) {
		case (pathname === '/' || pathname === '/select' || pathname == '/loading'):
			return null;
		case !!active:
			return null;
		case !!trial && lastTraffic === null:
			let adProtectAllow = (testData?.data?.afp_status || "off") !== "off";
			let addWebThreatAllow = (testData?.data?.wtp_status || "off") !== "off";
			if (pathname !== "/wtp/bot-activity" && pathname !== "/afp/current") {
				if (adProtectAllow || addWebThreatAllow) {
					let link = addWebThreatAllow ? "/wtp/bot-activity" : "/afp/current";
					return (<div className="warning-bar"><b>Trial mode:</b> Setup your Veracity Tag using the instructions <a href={link}>here to start your</a> {trial.length_on_start} day trial.</div>);
				}
			}
			let manageLink = "/manage/website"
			return (<div className="warning-bar"><b>Trial mode:</b> Setup your Veracity Tag using the instructions below to start your {trial.length_on_start} day trial. {adProtectAllow? <><a href={manageLink}>Click here</a> to connect your ad accounts.</> : ""}</div>);
		case !!trial:
			const trialLimit = {
				timeSpan: null,
				limitValue: null,
			};
			switch (true) {
				case !!trial.max_hourly_sessions:
					trialLimit.timeSpan = "hour";
					trialLimit.limitValue = trial.max_hourly_sessions;
					break;
				case !!trial.max_daily_sessions:
					trialLimit.timeSpan = "day";
					trialLimit.limitValue = trial.max_daily_sessions;
					break;
				case !!trial.max_monthly_sessions:
					trialLimit.timeSpan = "month";
					trialLimit.limitValue = trial.max_monthly_sessions;
					break;
				default:
					break
			};
			return (
				<div class="warning-bar">
					We're currently in the observation phase, with completion expected by <strong>{timeSplit(trial.end_date)}. </strong>
					{trialLimit.limitValue > 0 && (
						<>Our <strong>{trialLimit.limitValue} visits per {trialLimit.timeSpan} </strong> sample size ensures statistical significance for identifying <strong>meaningful hourly patterns </strong> and delivering <strong>precise, actionable insights </strong> into your site's traffic behaviour. </>
					) || (
							<>During this period we will be identifying <strong>meaningful hourly patterns</strong> and delivering <strong>precise, actionable insights</strong> into your site's traffic behaviour. </>
						)}
					Once observation concludes, we're excited to present how Veracity AI's solutions can optimise your results.
				</div>
			);
		case !!expired:
			return <div className="warning-bar"><b>No Protection:</b> Your licence expired on {timeSplit(expired.end_date)} and your website is not protected. Speak to your sales representative to activate your full licence and enable protection against malicious bots.</div>
		default:
			return null;
	};
};

export default MessageBar;

const timeSplit = (date) => {
	return moment(date).format("Do MMMM YYYY");
};
